module.exports = __webpack_public_path__ + "img/pr.212232ee.png";